import '../../../assets/value-multiple-item.css';
import { jsxs as d, jsx as e } from "react/jsx-runtime";
import f from "clsx";
import { forwardRef as I } from "react";
import { ItemContent as h } from "./item-content/item-content.js";
import { ItemIcon as u } from "./item-icon/item-icon.js";
import { ItemRemove as v } from "./item-remove/item-remove.js";
const x = "_item_dqyys_1", y = {
  item: x
}, R = I((t, m) => {
  const { className: r, disabled: i, startIcon: o, removeIcon: s, children: n, onRemove: l, ...c } = t, a = (p) => {
    p.stopPropagation(), l();
  };
  return /* @__PURE__ */ d("div", { ...c, ref: m, className: f(r, y.item), children: [
    o && /* @__PURE__ */ e(u, { children: o }),
    /* @__PURE__ */ e(h, { children: n }),
    /* @__PURE__ */ e(v, { disabled: i, onClick: a, children: s })
  ] });
});
R.displayName = "Combobox.Trigger.ValueMultiple.Item";
export {
  R as ValueMultipleItem
};
